import { theme } from 'antd'

export const defaultTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: '#01a3a3',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#f5222d',
    colorInfo: '#1890ff',
    colorBgBase: '#ffffff',
    colorTextBase: '#000000',
    colorBorder: '#d9d9d9',
    colorMeasurementProgramed: 'rgba(2, 180, 180, 0.83)',
    colorMeasurementActive: 'rgb(255, 154, 62)',
    colorMeasurementFinished: 'rgba(243, 167, 96, 0.75)',
  },
  components: {
    Button: {
      colorPrimary: '#1890ff',
    },
  },
}
// Helper function to create a theme object
const createIndustryTheme = tokens => ({
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: tokens.colorPrimary,
    colorSuccess: tokens.colorSuccess,
    colorWarning: tokens.colorWarning,
    colorError: tokens.colorError,
    colorInfo: tokens.colorInfo,
    colorBgBase: tokens.colorBgBase,
    colorTextBase: tokens.colorTextBase,
    colorBorder: tokens.colorBorder,
    colorMeasurementProgramed: tokens.colorMeasurementProgramed,
    colorMeasurementActive: tokens.colorMeasurementActive,
    colorMeasurementFinished: tokens.colorMeasurementFinished,
  },
  components: {
    Button: {
      colorPrimary: tokens.colorPrimary, // Using the main primary color for buttons
    },
  },
})

// --- Primary Sector Industries ---
//1 Agriculture
export const agricultureTheme = createIndustryTheme({
  colorPrimary: '#38761D',
  colorSuccess: '#52c41a',
  colorWarning: '#FAAD14',
  colorError: '#F5222D',
  colorInfo: '#1890FF',
  colorBgBase: '#FCFBF5',
  colorTextBase: '#3A3A3A',
  colorBorder: '#D3CBB8',
  colorMeasurementProgramed: 'rgba(160, 130, 100, 0.8)',
  colorMeasurementActive: 'rgba(76, 175, 80, 0.8)',
  colorMeasurementFinished: 'rgba(255, 193, 7, 0.75)',
})

//2 Forestry
export const forestryTheme = createIndustryTheme({
  colorPrimary: '#228B22',
  colorSuccess: '#4CAF50',
  colorWarning: '#FF9800',
  colorError: '#F44336',
  colorInfo: '#00ACC1',
  colorBgBase: '#F0F4F0',
  colorTextBase: '#36454F',
  colorBorder: '#C0C0C0',
  colorMeasurementProgramed: 'rgba(139, 69, 19, 0.7)',
  colorMeasurementActive: 'rgba(60, 179, 113, 0.8)',
  colorMeasurementFinished: 'rgba(210, 105, 30, 0.75)',
})

//3 Fishing and Hunting
export const fishingAndHuntingTheme = createIndustryTheme({
  colorPrimary: '#006994', // Fishing-centric
  colorSuccess: '#2E8B57',
  colorWarning: '#FFA500',
  colorError: '#DC143C',
  colorInfo: '#6082B6',
  colorBgBase: '#E8F0F2',
  colorTextBase: '#333333',
  colorBorder: '#BCC9C5',
  colorMeasurementProgramed: 'rgba(102, 102, 102, 0.8)',
  colorMeasurementActive: 'rgba(255, 107, 0, 0.8)',
  colorMeasurementFinished: 'rgba(75, 83, 32, 0.75)',
})

//4 Mining
export const miningTheme = createIndustryTheme({
  colorPrimary: '#708090',
  colorSuccess: '#B87333',
  colorWarning: '#FFA500',
  colorError: '#B22222',
  colorInfo: '#4682B4',
  colorBgBase: '#E5E5E5',
  colorTextBase: '#2C2C2C',
  colorBorder: '#A9A9A9',
  colorMeasurementProgramed: 'rgba(128, 128, 128, 0.8)',
  colorMeasurementActive: 'rgba(255, 165, 0, 0.8)',
  colorMeasurementFinished: 'rgba(101, 67, 33, 0.75)',
})

//5 Computer and Electronics
export const computerElectronicsTheme = createIndustryTheme({
  colorPrimary: '#007BFF',
  colorSuccess: '#28A745',
  colorWarning: '#FFC107',
  colorError: '#DC3545',
  colorInfo: '#17A2B8',
  colorBgBase: '#F8F9FA',
  colorTextBase: '#212529',
  colorBorder: '#DEE2E6',
  colorMeasurementProgramed: 'rgba(108, 117, 125, 0.8)',
  colorMeasurementActive: 'rgba(25, 135, 84, 0.8)',
  colorMeasurementFinished: 'rgba(0, 123, 255, 0.75)',
})

//6 Information Services and Data Processing
export const informationServicesDataProcessingTheme = createIndustryTheme({
  colorPrimary: '#0277BD',
  colorSuccess: '#2E7D32',
  colorWarning: '#FF8F00',
  colorError: '#C62828',
  colorInfo: '#0097A7',
  colorBgBase: '#FFFFFF',
  colorTextBase: '#37474F',
  colorBorder: '#B0BEC5',
  colorMeasurementProgramed: 'rgba(120, 144, 156, 0.8)',
  colorMeasurementActive: 'rgba(3, 169, 244, 0.8)',
  colorMeasurementFinished: 'rgba(76, 175, 80, 0.75)',
})

//7 Software
export const softwareTheme = createIndustryTheme({
  colorPrimary: '#1976D2', // Material Blue 700
  colorSuccess: '#388E3C', // Material Green 700
  colorWarning: '#FBC02D', // Material Yellow 700
  colorError: '#D32F2F', // Material Red 700
  colorInfo: '#0288D1', // Material Light Blue 700
  colorBgBase: '#FAFAFA', // Material Gray 50
  colorTextBase: '#212121', // Material Gray 900
  colorBorder: '#E0E0E0', // Material Gray 300
  colorMeasurementProgramed: 'rgba(144, 164, 174, 0.8)',
  colorMeasurementActive: 'rgba(255, 152, 0, 0.8)',
  colorMeasurementFinished: 'rgba(76, 175, 80, 0.75)',
})

//8 Telecommunications
export const telecommunicationsTheme = createIndustryTheme({
  colorPrimary: '#00529B',
  colorSuccess: '#2E7D32',
  colorWarning: '#FF8F00',
  colorError: '#C62828',
  colorInfo: '#0077C2',
  colorBgBase: '#F4F7F9',
  colorTextBase: '#1D2C38',
  colorBorder: '#CED9E0',
  colorMeasurementProgramed: 'rgba(128, 128, 128, 0.8)',
  colorMeasurementActive: 'rgba(0, 178, 128, 0.8)',
  colorMeasurementFinished: 'rgba(0, 82, 155, 0.75)',
})

//9 Broadcasting
export const broadcastingTheme = createIndustryTheme({
  colorPrimary: '#007ACC',
  colorSuccess: '#008000',
  colorWarning: '#FFD700',
  colorError: '#CC0000',
  colorInfo: '#00A896',
  colorBgBase: '#ECECEC',
  colorTextBase: '#1C1C1C',
  colorBorder: '#BDBDBD',
  colorMeasurementProgramed: 'rgba(128, 128, 128, 0.8)',
  colorMeasurementActive: 'rgba(220, 20, 60, 0.8)',
  colorMeasurementFinished: 'rgba(0, 128, 0, 0.75)',
})

//10 Finance and Insurance
export const financeInsuranceTheme = createIndustryTheme({
  colorPrimary: '#005A9C',
  colorSuccess: '#28A745',
  colorWarning: '#FFC107',
  colorError: '#DC3545',
  colorInfo: '#17A2B8',
  colorBgBase: '#F8F9FA',
  colorTextBase: '#212529',
  colorBorder: '#CED4DA',
  colorMeasurementProgramed: 'rgba(108, 117, 125, 0.8)',
  colorMeasurementActive: 'rgba(0, 90, 156, 0.8)',
  colorMeasurementFinished: 'rgba(40, 167, 69, 0.75)',
})

//11 Legal Services
export const legalServicesTheme = createIndustryTheme({
  colorPrimary: '#003366',
  colorSuccess: '#228B22',
  colorWarning: '#B8860B',
  colorError: '#8B0000',
  colorInfo: '#4682B4',
  colorBgBase: '#FDFDFD',
  colorTextBase: '#1A1A1A',
  colorBorder: '#AEB6BF',
  colorMeasurementProgramed: 'rgba(128, 128, 128, 0.8)',
  colorMeasurementActive: 'rgba(0, 51, 102, 0.8)',
  colorMeasurementFinished: 'rgba(112, 128, 144, 0.75)',
})

//12 Scientific or Technical Services
export const scientificTechnicalServicesTheme = createIndustryTheme({
  colorPrimary: '#004C8C',
  colorSuccess: '#4CAF50',
  colorWarning: '#FF9800',
  colorError: '#F44336',
  colorInfo: '#00BCD4',
  colorBgBase: '#EFF2F5',
  colorTextBase: '#263238',
  colorBorder: '#BCCCDC',
  colorMeasurementProgramed: 'rgba(176, 190, 197, 0.8)',
  colorMeasurementActive: 'rgba(33, 150, 243, 0.8)',
  colorMeasurementFinished: 'rgba(124, 179, 66, 0.75)',
})

//13 Wholesale
export const wholesaleTheme = createIndustryTheme({
  colorPrimary: '#0073B7',
  colorSuccess: '#5CB85C',
  colorWarning: '#F0AD4E',
  colorError: '#D9534F',
  colorInfo: '#5BC0DE',
  colorBgBase: '#F5F5F5',
  colorTextBase: '#333333',
  colorBorder: '#DDDDDD',
  colorMeasurementProgramed: 'rgba(119, 119, 119, 0.8)',
  colorMeasurementActive: 'rgba(240, 173, 78, 0.8)',
  colorMeasurementFinished: 'rgba(92, 184, 92, 0.75)',
})

//14 Public Sector & Education
export const governmentPublicAdministrationTheme = createIndustryTheme({
  colorPrimary: '#0033A0',
  colorSuccess: '#2E8540',
  colorWarning: '#B45F06',
  colorError: '#B22234',
  colorInfo: '#0072C6',
  colorBgBase: '#FFFFFF',
  colorTextBase: '#212121',
  colorBorder: '#A9A9A9',
  colorMeasurementProgramed: 'rgba(110, 110, 110, 0.8)',
  colorMeasurementActive: 'rgba(0, 51, 160, 0.8)',
  colorMeasurementFinished: 'rgba(60, 118, 61, 0.75)',
})

//15 College, University, and Adult Education
export const collegeUniversityAdultEducationTheme = createIndustryTheme({
  colorPrimary: '#003865',
  colorSuccess: '#3A7D34',
  colorWarning: '#B5A66B',
  colorError: '#84344E',
  colorInfo: '#59B2D1',
  colorBgBase: '#F8F8F8',
  colorTextBase: '#333333',
  colorBorder: '#C0C0C0',
  colorMeasurementProgramed: 'rgba(130, 130, 130, 0.8)',
  colorMeasurementActive: 'rgba(0, 56, 101, 0.8)',
  colorMeasurementFinished: 'rgba(181, 166, 107, 0.75)',
})

//16 Primary/Secondary (K-12) Education
export const primarySecondaryK12EducationTheme = createIndustryTheme({
  // Younger Children focus
  colorPrimary: '#FFC107',
  colorSuccess: '#4CAF50',
  colorWarning: '#FF9800',
  colorError: '#F44336',
  colorInfo: '#2196F3',
  colorBgBase: '#FFFFFF',
  colorTextBase: '#333333',
  colorBorder: '#BDBDBD',
  colorMeasurementProgramed: 'rgba(158, 158, 158, 0.8)',
  colorMeasurementActive: 'rgba(255, 87, 34, 0.8)',
  colorMeasurementFinished: 'rgba(76, 175, 80, 0.75)',
})

//17 Military
export const militaryTheme = createIndustryTheme({
  colorPrimary: '#556B2F',
  colorSuccess: '#6B8E23',
  colorWarning: '#BDB76B',
  colorError: '#8B0000',
  colorInfo: '#4A4E54',
  colorBgBase: '#DCDCDC',
  colorTextBase: '#202020',
  colorBorder: '#A9A9A9',
  colorMeasurementProgramed: 'rgba(100, 100, 100, 0.8)',
  colorMeasurementActive: 'rgba(178, 34, 34, 0.8)',
  colorMeasurementFinished: 'rgba(85, 107, 47, 0.75)',
})

//18 Creative, Leisure & Lifestyle
export const artsEntertainmentRecreationTheme = createIndustryTheme({
  colorPrimary: '#9C27B0',
  colorSuccess: '#4CAF50',
  colorWarning: '#FFEB3B',
  colorError: '#F44336',
  colorInfo: '#FF7043',
  colorBgBase: '#FFF9F0',
  colorTextBase: '#2A2A2A',
  colorBorder: '#E0E0E0',
  colorMeasurementProgramed: 'rgba(186, 104, 200, 0.8)',
  colorMeasurementActive: 'rgba(255, 112, 67, 0.8)',
  colorMeasurementFinished: 'rgba(126, 87, 194, 0.75)',
})

//19 Publishing
export const publishingTheme = createIndustryTheme({
  colorPrimary: '#006699',
  colorSuccess: '#5A945A',
  colorWarning: '#A0522D',
  colorError: '#8B0000',
  colorInfo: '#333333',
  colorBgBase: '#FCFBF8',
  colorTextBase: '#1A1A1A',
  colorBorder: '#DCDCDC',
  colorMeasurementProgramed: 'rgba(150, 150, 150, 0.8)',
  colorMeasurementActive: 'rgba(0, 102, 153, 0.8)',
  colorMeasurementFinished: 'rgba(85, 85, 85, 0.75)',
})

//20 Real Estate, Rental and Leasing
export const religiousTheme = createIndustryTheme({
  colorPrimary: '#7B5AA6',
  colorSuccess: '#66BB6A',
  colorWarning: '#FFD700',
  colorError: '#B71C1C',
  colorInfo: '#81D4FA',
  colorBgBase: '#F5F5F0',
  colorTextBase: '#4A4A4A',
  colorBorder: '#D1C4E9',
  colorMeasurementProgramed: 'rgba(171, 130, 197, 0.8)',
  colorMeasurementActive: 'rgba(255, 215, 0, 0.8)',
  colorMeasurementFinished: 'rgba(123, 90, 166, 0.75)',
})

//21 Religious
export const homemakerTheme = createIndustryTheme({
  colorPrimary: '#FFDAB9',
  colorSuccess: '#90EE90',
  colorWarning: '#FFEBCD',
  colorError: '#FA8072',
  colorInfo: '#A0D2DB',
  colorBgBase: '#FFFDF5',
  colorTextBase: '#5A5A5A',
  colorBorder: '#E0D8CC',
  colorMeasurementProgramed: 'rgba(192, 192, 192, 0.8)',
  colorMeasurementActive: 'rgba(255, 182, 193, 0.8)',
  colorMeasurementFinished: 'rgba(173, 216, 230, 0.75)',
})

//22 Homemaker
export const constructionTheme = createIndustryTheme({
  colorPrimary: '#FFC107',
  colorSuccess: '#4CAF50',
  colorWarning: '#FF8C00',
  colorError: '#D9534F',
  colorInfo: '#36454F',
  colorBgBase: '#E9ECEF',
  colorTextBase: '#212529',
  colorBorder: '#ADB5BD',
  colorMeasurementProgramed: 'rgba(108, 117, 125, 0.8)',
  colorMeasurementActive: 'rgba(255, 193, 7, 0.8)',
  colorMeasurementFinished: 'rgba(76, 86, 95, 0.75)',
})

//23 Hotel and Food Services
export const hotelTheme = createIndustryTheme({
  // Hotel - Elegant & Calm
  colorPrimary: '#B0C4DE',
  colorSuccess: '#BFD8AF',
  colorWarning: '#F0E68C',
  colorError: '#DDA0DD',
  colorInfo: '#F5F5DC',
  colorBgBase: '#FFFFFF',
  colorTextBase: '#5A5A5A',
  colorBorder: '#DCDCDC',
  colorMeasurementProgramed: 'rgba(176, 196, 222, 0.8)',
  colorMeasurementActive: 'rgba(218, 165, 32, 0.8)',
  colorMeasurementFinished: 'rgba(119, 136, 153, 0.75)',
})

//24 Food Service
export const foodServiceTheme = createIndustryTheme({
  // Food Service - Appetizing & Vibrant
  colorPrimary: '#FF8C00',
  colorSuccess: '#8BC34A',
  colorWarning: '#FFEB3B',
  colorError: '#FF5722',
  colorInfo: '#4E342E',
  colorBgBase: '#FFF3E0',
  colorTextBase: '#4E342E',
  colorBorder: '#FFE0B2',
  colorMeasurementProgramed: 'rgba(190, 140, 100, 0.8)',
  colorMeasurementActive: 'rgba(255, 110, 64, 0.8)',
  colorMeasurementFinished: 'rgba(139, 195, 74, 0.75)',
})

//25 Retail
export const retailTheme = createIndustryTheme({
  colorPrimary: '#FF5722',
  colorSuccess: '#8BC34A',
  colorWarning: '#FFC107',
  colorError: '#F44336',
  colorInfo: '#03A9F4',
  colorBgBase: '#FFF8E1',
  colorTextBase: '#212121',
  colorBorder: '#FFCCBC',
  colorMeasurementProgramed: 'rgba(255, 87, 34, 0.8)',
  colorMeasurementActive: 'rgba(139, 195, 74, 0.8)',
  colorMeasurementFinished: 'rgba(255, 152, 0, 0.75)',
})

//26 Transportation and Warehousing
export const transportationTheme = createIndustryTheme({
  colorPrimary: '#607D8B',
  colorSuccess: '#4CAF50',
  colorWarning: '#FFC107',
  colorError: '#D32F2F',
  colorInfo: '#2196F3',
  colorBgBase: '#ECEFF1',
  colorTextBase: '#263238',
  colorBorder: '#B0BEC5',
  colorMeasurementProgramed: 'rgba(96, 125, 139, 0.8)',
  colorMeasurementActive: 'rgba(76, 175, 80, 0.8)',
  colorMeasurementFinished: 'rgba(33, 150, 243, 0.75)',
})

//27 Utilities
export const utilitiesTheme = createIndustryTheme({
  colorPrimary: '#795548',
  colorSuccess: '#4CAF50',
  colorWarning: '#FFC107',
  colorError: '#E53935',
  colorInfo: '#8D6E63',
  colorBgBase: '#EFEBE9',
  colorTextBase: '#3E2723',
  colorBorder: '#D7CCC8',
  colorMeasurementProgramed: 'rgba(121, 85, 72, 0.8)',
  colorMeasurementActive: 'rgba(76, 175, 80, 0.8)',
  colorMeasurementFinished: 'rgba(255, 152, 0, 0.75)',
})

//28 Wholesale
// These are light theme variations based on the previous detailed discussion.

//13 Health Care and Social Assistance
export const healthCareSocialAssistanceTheme = createIndustryTheme({
  colorPrimary: '#00BFA6',
  colorSuccess: '#4CAF50',
  colorWarning: '#FFC107',
  colorError: '#E53935',
  colorInfo: '#0097A7',
  colorBgBase: '#F1F8E9',
  colorTextBase: '#263238',
  colorBorder: '#B2DFDB',
  colorMeasurementProgramed: 'rgba(0, 191, 166, 0.8)',
  colorMeasurementActive: 'rgba(76, 175, 80, 0.8)',
  colorMeasurementFinished: 'rgba(0, 151, 167, 0.75)',
})

//16 Manufacturing
export const manufacturingTheme = createIndustryTheme({
  colorPrimary: '#607D8B',
  colorSuccess: '#8BC34A',
  colorWarning: '#FFB300',
  colorError: '#D32F2F',
  colorInfo: '#0288D1',
  colorBgBase: '#ECEFF1',
  colorTextBase: '#37474F',
  colorBorder: '#CFD8DC',
  colorMeasurementProgramed: 'rgba(96, 125, 139, 0.8)',
  colorMeasurementActive: 'rgba(139, 195, 74, 0.8)',
  colorMeasurementFinished: 'rgba(28, 134, 238, 0.75)',
})

//20 Real Estate, Rental and Leasing
export const realEstateTheme = createIndustryTheme({
  colorPrimary: '#3F51B5',
  colorSuccess: '#4CAF50',
  colorWarning: '#FFC107',
  colorError: '#F44336',
  colorInfo: '#2196F3',
  colorBgBase: '#F8F9FA',
  colorTextBase: '#212121',
  colorBorder: '#E0E0E0',
  colorMeasurementProgramed: 'rgba(63, 81, 181, 0.8)',
  colorMeasurementActive: 'rgba(76, 175, 80, 0.8)',
  colorMeasurementFinished: 'rgba(33, 150, 243, 0.75)',
})

//29 Other
export const otherTheme = createIndustryTheme({
  colorPrimary: '#9E9E9E',
  colorSuccess: '#607D8B',
  colorWarning: '#FFC107',
  colorError: '#F44336',
  colorInfo: '#2196F3',
  colorBgBase: '#FAFAFA',
  colorTextBase: '#212121',
  colorBorder: '#BDBDBD',
  colorMeasurementProgramed: 'rgba(158, 158, 158, 0.8)',
  colorMeasurementActive: 'rgba(96, 125, 139, 0.8)',
  colorMeasurementFinished: 'rgba(33, 150, 243, 0.75)',
})

export const industryThemes = {
  0: defaultTheme,
  default: defaultTheme,
  1: agricultureTheme,
  2: forestryTheme,
  3: fishingAndHuntingTheme,
  4: artsEntertainmentRecreationTheme,
  5: broadcastingTheme,
  6: collegeUniversityAdultEducationTheme,
  7: computerElectronicsTheme,
  8: constructionTheme,
  9: financeInsuranceTheme,
  10: governmentPublicAdministrationTheme,
  11: homemakerTheme,
  12: hotelTheme,
  13: healthCareSocialAssistanceTheme,
  14: informationServicesDataProcessingTheme,
  15: legalServicesTheme,
  16: manufacturingTheme,
  17: militaryTheme,
  18: primarySecondaryK12EducationTheme,
  19: publishingTheme,
  20: realEstateTheme,
  21: religiousTheme,
  22: retailTheme,
  23: scientificTechnicalServicesTheme,
  24: softwareTheme,
  25: telecommunicationsTheme,
  26: transportationTheme,
  27: utilitiesTheme,
  28: wholesaleTheme,
  29: otherTheme,
}
